const themes = {
  rez: {
    'background-color': 'rgb(255,254,200)',
    'text-color': 'rgb(96,144,114)',
    'link-color': 'rgb(188,75,45)',
    'accent-color': 'rgb(75,12,11)',
    'shadow-color': 'rgba(96,144,114,0.6)'
  },
  'eve-1': {
    'background-color': 'rgb(29,47,56)',
    'text-color': 'rgb(96,144,114)',
    'link-color': 'rgb(188,75,45)',
    'accent-color': 'rgb(255,254,200)',
    'shadow-color': 'rgba(96,144,114,0.6)'
  },
  'eve-4': {
    'background-color': 'rgb(149,160,177)',
    'text-color': 'rgb(22,48,71)',
    'link-color': 'rgb(186,216,195)',
    'accent-color': 'rgb(241,255,250)',
    'shadow-color': 'rgba(22,48,71,0.6)'
  },
  'eve-6': {
    'background-color': 'rgb(170,172,161)',
    'text-color': 'rgb(99,113,100)',
    'link-color': 'rgb(152,113,121)',
    'accent-color': 'rgb(241,247,238)',
    'shadow-color': 'rgba(99,113,100,0.6)'
  },
  'eve-7': {
    'background-color': 'rgb(104,106,95)',
    'text-color': 'rgb(189,152,69)',
    'link-color': 'rgb(1,36,2)',
    'accent-color': 'rgb(50,3,31)',
    'shadow-color': 'rgba(189,152,69,0.6)'
  },
  'eve-8': {
    'background-color': 'rgb(68,112,137)',
    'accent-color': 'rgb(238,158,174)',
    'link-color': 'rgb(163,146,226)',
    'text-color': 'rgb(194,178,180)',
    'shadow-color': 'rgba(238,158,174,0.6)'
  },
};

export default themes;



// WEBPACK FOOTER //
// ./src/data/themes.js